/**
 * Hides the product card dots-spinner preloader when the first image in that card loads.
 * Fixes cards stuck in loading state when the main bundle's preloader logic doesn't run (e.g. timing or shadow DOM).
 *
 * Debug: In the browser console run: window.PRODUCT_CARD_PRELOADER_DEBUG = true then reload.
 * You will see logs when preloaders are set up and when each is hidden (with product id if available).
 * Look for: "no img in container" (card has no image), "image error" (image failed to load), or missing product id.
 */
(function () {
  'use strict';
  var DEBUG = typeof window !== 'undefined' && window.PRODUCT_CARD_PRELOADER_DEBUG === true;

  function hidePreloader(preloader) {
    if (!preloader || preloader._preloaderHidden) return;
    preloader._preloaderHidden = true;
    preloader.style.display = 'none';
  }

  function getCardRoot(card) {
    return (card && (card.shadowRoot || card)) || card;
  }

  function getProductIdFromCard(card) {
    if (!card) return null;
    var root = getCardRoot(card);
    var script = root.querySelector && root.querySelector('script[data-product-id]');
    if (script) return script.getAttribute('data-product-id');
    var inner = root.querySelector && root.querySelector('[data-product-card-inner]');
    if (inner) {
      var idEl = root.querySelector('[data-product-card-variants]');
      if (idEl) return idEl.getAttribute('data-product-id');
    }
    return null;
  }

  function setupPreloader(preloader) {
    if (!preloader || preloader._preloaderSetup) return;
    var card = preloader.closest && (preloader.closest('product-card') || preloader.closest('.product-card'));
    if (!card) {
      if (DEBUG) console.log('[product-card-preloader] preloader has no product-card parent', preloader);
      return;
    }
    preloader._preloaderSetup = true;
    var root = getCardRoot(card);
    var container = root.querySelector && root.querySelector('[data-product-card-media-container]');
    if (!container) {
      if (DEBUG) console.log('[product-card-preloader] no media container, product id:', getProductIdFromCard(card));
      return;
    }
    var firstImg = container.querySelector && container.querySelector('img[data-product-card-featured-image], img.product-card__img, img[data-main-media], img');
    if (!firstImg) {
      if (DEBUG) console.log('[product-card-preloader] no img in container, product id:', getProductIdFromCard(card));
      return;
    }
    var productId = getProductIdFromCard(card);
    function done() {
      hidePreloader(preloader);
      if (DEBUG) console.log('[product-card-preloader] hidden for product id:', productId);
    }
    if (firstImg.complete && firstImg.naturalWidth > 0) {
      done();
      return;
    }
    firstImg.addEventListener('load', done, { once: true });
    firstImg.addEventListener('error', function () {
      if (DEBUG) console.warn('[product-card-preloader] image error for product id:', productId, 'src:', firstImg.src);
      done();
    }, { once: true });
  }

  function runForAllPreloaders() {
    var seen = 0;
    var preloaders = document.querySelectorAll('[data-product-card-preloader]');
    for (var i = 0; i < preloaders.length; i++) {
      setupPreloader(preloaders[i]);
      if (preloaders[i]._preloaderSetup) seen++;
    }
    var cards = document.querySelectorAll('product-card, .product-card');
    for (var c = 0; c < cards.length; c++) {
      var root = getCardRoot(cards[c]);
      if (root === document) continue;
      var inside = root.querySelectorAll && root.querySelectorAll('[data-product-card-preloader]');
      if (inside) {
        for (var j = 0; j < inside.length; j++) {
          setupPreloader(inside[j]);
          if (inside[j]._preloaderSetup) seen++;
        }
      }
    }
    if (DEBUG) console.log('[product-card-preloader] run complete, preloaders set up');
  }

  function onReady() {
    runForAllPreloaders();
    var observer = new MutationObserver(function (mutations) {
      var run = false;
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var i = 0; i < added.length; i++) {
          var node = added[i];
          if (node.nodeType !== 1) continue;
          if (node.hasAttribute && node.hasAttribute('data-product-card-preloader')) run = true;
          else if (node.querySelector && node.querySelector('[data-product-card-preloader]')) run = true;
          else if (node.tagName === 'PRODUCT-CARD' || (node.classList && node.classList.contains('product-card'))) run = true;
        }
      }
      if (run) runForAllPreloaders();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    if (DEBUG) console.log('[product-card-preloader] init done, MutationObserver attached');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
